import { brand, stats } from "@/mocks/chigua";

function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[88vh] items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20abstract%20editorial%20background%20of%20interconnected%20glowing%20threads%20of%20light%20in%20deep%20charcoal%20black%2C%20subtle%20coral%20red%20and%20watermelon%20green%20accent%20lights%20weaving%20through%20darkness%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20high%20contrast%20minimal%20art%20backdrop&width=1800&height=1100&seq=chigua-hero&orientation=landscape"
          alt="吃瓜黑屋深色编辑风背景，暗色中交织的红色与绿色光丝"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/85 via-background-950/70 to-background-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-transparent to-background-950/40"></div>
      </div>

      <div className="container-x w-full py-20 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-500/10 px-4 py-1.5 text-sm text-accent-300">
              <span className="flex h-2 w-2 items-center justify-center">
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400"></span>
              </span>
              独立娱乐观察 · 已深耕 {new Date().getFullYear() - brand.established}+ 年
            </p>

            <h2 className="font-serif text-4xl font-black leading-tight tracking-tight text-foreground-50 md:text-6xl">
              热点背后的<span className="text-primary-400">真实脉络</span>，
              <br className="hidden md:block" />
              我们替你把瓜看透。
            </h2>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-300 md:text-lg">
              {brand.desc} 不追风口、不消费当事人，只把热闹放回创作过程、行业逻辑与社会情绪里，讲给你听。
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#featured"
                className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-medium text-background-950 transition-colors hover:bg-primary-400"
              >
                去看深度追踪
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
              </a>
              <a
                href="#story"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-700 px-7 py-3.5 text-base text-foreground-100 transition-colors hover:border-accent-500/60 hover:text-accent-300"
              >
                <i className="ri-play-list-2-line text-lg" aria-hidden="true"></i>
                本周专题精选
              </a>
            </div>

            <dl className="mt-12 grid max-w-xl grid-cols-2 gap-x-6 gap-y-6 border-t border-background-800 pt-7 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label}>
                  <dd className="font-serif text-2xl font-bold text-accent-400 md:text-3xl">
                    {s.value}
                  </dd>
                  <dt className="mt-1 text-sm text-foreground-400">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="hidden lg:col-span-5 lg:block">
            <div className="rounded-2xl border border-background-800 bg-background-900/60 p-7 backdrop-blur-sm">
              <div className="flex items-center justify-between">
                <p className="font-serif text-lg font-semibold text-foreground-100">
                  编辑手记
                </p>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500/15 text-accent-400">
                  <i className="ri-quill-pen-line" aria-hidden="true"></i>
                </span>
              </div>
              <p className="mt-5 font-serif text-xl leading-relaxed text-foreground-200 md:text-2xl">
                「算法把信息喂到嘴边，热搜把情绪推到顶点。当“看到”越来越容易，“相信”反而成了稀缺能力——这就是我们仍在认真写字的理由。」
              </p>
              <div className="mt-6 flex items-center gap-3 border-t border-background-800 pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-950">
                  <i className="ri-user-smile-line text-lg" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-100">黑屋编辑部</p>
                  <p className="text-xs text-foreground-500">本周 · 主编手记</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 md:block">
        <a
          href="#hot"
          aria-label="向下浏览热榜"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-foreground-300 transition-colors hover:text-accent-300"
        >
          <i className="ri-arrow-down-line" aria-hidden="true"></i>
        </a>
      </div>
    </section>
  );
}

export default Hero;